import axiosInstance from "../api/axios";
import { useFreeHistoryStore } from "../stores/freeHistoryStore";

//Is blocked is a boolean that means that the user used all of his free content. 
//IsBlocked is used before any request if the user is free.
//ViewedContent is an array of objects that contains the content slug and if it is valid.
export const viewContent = async (slug: string, id: string, type: string) => {
  try {
    const { setIsBlocked, setViewedContent } = useFreeHistoryStore.getState()

    const { data } = await axiosInstance.post(`/universitario/history`, { 
      contentId: id,
      contentType: type,
      contentSlug: slug,
    });

    const { data: dataResponse } = data;

    setViewedContent(dataResponse.contents)
    setIsBlocked(dataResponse.isBlocked)
  
    return true;
  } catch (error: any) {
    console.log(error)
    throw new Error(error.message);
  }
};


